var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonHaptics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#007AFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1268_2396)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1268_2396",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 7,
    width: 12,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7H9V23H21V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1268_2396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9C9.5 7.89688 10.3969 7 11.5 7H18.5C19.6032 7 20.5 7.89688 20.5 9V21C20.5 22.1031 19.6032 23 18.5 23H11.5C10.3969 23 9.5 22.1031 9.5 21V9ZM16 21C16 20.7348 15.8946 20.4804 15.7071 20.2929C15.5196 20.1054 15.2652 20 15 20C14.7348 20 14.4804 20.1054 14.2929 20.2929C14.1054 20.4804 14 20.7348 14 21C14 21.2652 14.1054 21.5196 14.2929 21.7071C14.4804 21.8946 14.7348 22 15 22C15.2652 22 15.5196 21.8946 15.7071 21.7071C15.8946 21.5196 16 21.2652 16 21ZM18.5 9H11.5V19H18.5V9Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1268_2396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "white",
    transform: "translate(9 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonHaptics);
export default __webpack_public_path__ + "static/media/ButtonHaptics.f6ee19bc0f18fe9e05aed5d79f1a056f.svg";
export { ForwardRef as ReactComponent };